import { UserEsercitazioneDomanda } from './useresercitazionedomanda';

export class UserEsercitazione {
    id: number;
    userId: string;
    moduloId: number;
    esercitazioneId: number;
    dataEsercitazione: Date;
    numDomande: number;
    numRisposteToPass: number;
    numRisposteCorrette: number;
    fileAudio: string;
    domande: Array<UserEsercitazioneDomanda>;
}
